import React, { createContext, useState, useEffect } from "react"
import API from "../../api/api"
import testJobOrderData from "../../test/jobOrderList.json"
import jobTableTitle from "../../constants/JobTableTitle.json"
import { db } from "../../helpers/firebase_helper"
import { use } from "echarts"

export const OrderListContext = createContext()

/**
 * This is the provider that is used to wrap the Order list container to access the context in OrderList.jsx
 * @param {Object} children
 * @returns {Object}
 */
export const OrderListContextProvider = ({ children }) => {
  const [jobOrderData, setJobOrderData] = useState([])
  const [totalPagesCount, setTotalPagesCount] = useState([])
  const [lastDoc, setLastDoc] = useState()
  const [firstDoc, setFirstDoc] = useState()
  const [pageNumberThreshold, setPageNumberThreshold] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [orderType, setOrderType] = useState("Assigned")

  /**
   * FIREBASE INTEGRATION
   */

  const getJobOrderData = async () => {
    let jobOrders = []

    const snapshotForPages =
      orderType === "Unassigned"
        ? await db
            .collection("orders")
            .where("status", "==", "OPEN")
            .where("updatedAt", "<", new Date(Date.now() - 5 * 60000))
            .get()
        : await db.collection("orders").orderBy("from", "desc").get()
    Math.ceil(snapshotForPages.size / 10)

    const totalPages = snapshotForPages.size / 10
    setTotalPagesCount(totalPages)

    const snapshot =
      orderType === "Unassigned"
        ? await db
            .collection("orders")
            .where("status", "==", "OPEN")
            .where("updatedAt", "<", new Date(Date.now() - 5 * 60000))
            .limit(10)
            .get()
        : await db.collection("orders").orderBy("from", "desc").limit(10).get()
    const lastItem = snapshot.docs[snapshot.size - 1].data().from
    const firstItem = snapshot.docs[0].data().from
    setLastDoc(lastItem)
    setFirstDoc(firstItem)
    await snapshot.forEach(async (doc, index) => {
      jobOrders.push({ ...doc.data(), id: doc.id })
    })

    setJobOrderData(jobOrders)
    setJobOrderData(jobOrders)
  }

  const nextPage = async currentPageNumber => {
    setPageNumberThreshold((currentPageNumber - 1) * 10)
    if (currentPageNumber > currentPage) {
      setCurrentPage(currentPageNumber)
      let jobOrders = []
      const snapshot =
        orderType === "Unassigned"
          ? await db
              .collection("orders")
              .where("status", "==", "OPEN")
              .where("updatedAt", "<", new Date(Date.now() - 5 * 60000))
              .startAfter(lastDoc)
              .limit(10)
              .get()
          : await db
              .collection("orders")
              .orderBy("from", "desc")
              .startAfter(lastDoc)
              .limit(10)
              .get()
      const lastItem = snapshot.docs[snapshot.size - 1].data().from
      const firstItem = snapshot.docs[0].data().from
      setFirstDoc(firstItem)
      setLastDoc(lastItem)
      await snapshot.forEach(async (doc, index) => {
        jobOrders.push({ ...doc.data(), id: doc.id })
      })
      setJobOrderData(jobOrders)
    } else {
      let jobOrders = []
      const snapshot =
        orderType === "Unassigned"
          ? await db
              .collection("orders")
              .where("status", "==", "OPEN")
              .where("updatedAt", "<", new Date(Date.now() - 5 * 60000))
              .startAfter(firstDoc)
              .limit(10)
              .get()
          : await db
              .collection("orders")
              .orderBy("from", "desc")
              .startAfter(firstDoc)
              .limit(10)
              .get()
      const lastItem = snapshot.docs[snapshot.size - 1].data().from
      const firstItem = snapshot.docs[0].data().from
      setFirstDoc(firstItem)
      setLastDoc(lastItem)
      await snapshot.forEach(async (doc, index) => {
        jobOrders.push({ ...doc.data(), id: doc.id })
      })
      setJobOrderData(jobOrders)
    }
  }

  useEffect(() => {
    getJobOrderData()
  }, [orderType])

  const providerValue = {
    jobOrderData,
    jobTableTitle,
    totalPagesCount,
    nextPage,
    pageNumberThreshold,
    currentPage,
    setCurrentPage,
    orderType,
    setOrderType,
  }

  return (
    <OrderListContext.Provider value={providerValue}>
      {children}
    </OrderListContext.Provider>
  )
}

//TODO: REPLACE THE STATIC DATA PROVIDED TO ORDER DATA WHEN API ISSUE IS FIXED
